var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.25V17.5C19.5 18.6051 18.6051 19.5 17.5 19.5H14.25V18H18V14.25H19.5ZM2 14.25V18H5.75V19.5H2.5C1.39489 19.5 0.5 18.6051 0.5 17.5V14.25H2ZM11.4199 6.93652C13.1095 6.33813 14.9679 7.22432 15.5664 8.91699C16.1647 10.6064 15.2792 12.4638 13.5869 13.0625L13.5859 13.0635C11.8964 13.6616 10.0389 12.7756 9.44043 11.083L9.32227 10.75H5.75V12H4.25V9.25H9.32324L9.44043 8.91602C9.74469 8.0514 10.4034 7.35658 11.248 7.00293L11.4199 6.93652ZM12.5 8.25C11.5332 8.25 10.75 9.03323 10.75 10C10.75 10.9668 11.5332 11.75 12.5 11.75C13.4668 11.75 14.25 10.9668 14.25 10C14.25 9.03323 13.4668 8.25 12.5 8.25ZM17.5 0.5C18.6051 0.5 19.5 1.39489 19.5 2.5V5.75H18V2H14.25V0.5H17.5ZM2.5 0.5H5.75V2H2V5.75H0.5V2.5C0.5 1.39489 1.39489 0.5 2.5 0.5Z",
    fill: "#DC3A3F",
    stroke: "#E13E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/changePassword.ec5b813c146c9b8543ce40462cf0d3dd.svg";
export { ForwardRef as ReactComponent };